import { Box, Icon, Menu } from '@zillow/constellation-10';
import { IconCheckmarkOutline } from '@zillow/constellation-icons';

type FolderSelectorMenuItemProps = {
  itemLabel: string;
  icon: React.ReactNode;
  onItemClick: () => void;
  isActive: boolean;
};

const Checkmark = () => {
  return (
    <Box css={{ display: 'flex', alignItems: 'center' }}>
      <Icon role="img" size="md" css={{ position: 'absolute', left: '85%', transform: 'translate(-50%, -50%)' }}>
        <IconCheckmarkOutline />
      </Icon>
    </Box>
  );
};

export default function FolderSelectorMenuItem({
  itemLabel,
  icon,
  onItemClick,
  isActive,
}: FolderSelectorMenuItemProps) {
  return (
    <Menu.Item onClick={onItemClick} data-testid={`folder-selector-menu-item-${itemLabel.toLowerCase()}`}>
      <Menu.ItemIcon render={icon} />
      <Menu.ItemLabel>{itemLabel}</Menu.ItemLabel>
      {isActive && <Checkmark />}
    </Menu.Item>
  );
}
